import { render, staticRenderFns } from "./InternalRequestByModuleMontlyReport.vue?vue&type=template&id=51588b04&scoped=true&"
import script from "./InternalRequestByModuleMontlyReport.vue?vue&type=script&lang=js&"
export * from "./InternalRequestByModuleMontlyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51588b04",
  null
  
)

export default component.exports